module.exports = __webpack_public_path__ + "static/media/ironman.d0bc33ff.jpg";